import { DateRange } from 'react-day-picker';
import { DateRangeStepType } from './MDateRangeFilterButton.model';

const moveDate = (direction: DateRangeStepDirections, step: number, date: DateRange) => {
  if (direction === DateRangeStepDirections.Prev) {
    date.to = new Date(date.from!);
    date.from!.setDate(date.from!.getDate() + step);
  } else if (direction === DateRangeStepDirections.Next) {
    date.from = new Date(date.to!);
    date.to!.setDate(date.to!.getDate() + step);
  }
};

const changeDate = (stepType: DateRangeStepType, date: DateRange, direction: DateRangeStepDirections): void => {
  switch (stepType) {
    case DateRangeStepType.Week: {
      const step: number = direction === DateRangeStepDirections.Prev ? -7 : 7;

      moveDate(direction, step, date);

      break;
    }
    case DateRangeStepType.Day: {
      const step: number = direction === DateRangeStepDirections.Prev ? -1 : 1;

      moveDate(direction, step, date);

      break;
    }
    case DateRangeStepType.Month: {
      const step: number = direction === DateRangeStepDirections.Prev ? -1 : 1;

      moveDate(direction, step, date);

      break;
    }
  }
};

export enum DateRangeStepDirections {
  Next = 'next',
  Prev = 'prev',
}

export default changeDate;
